import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import LocationOnTwoToneIcon from "@mui/icons-material/LocationOnTwoTone";

const AddressCard = ({languageWords,Css}) => {
  const theme = useTheme();
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  const {widgetSettings}=useSelector((store)=> store?.salon)
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: Css?.salonCardSectionBgClr,
        borderRadius: '16px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        p:1.8,
        mt: 2,
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0px 6px 14px rgba(0, 0, 0, 0.15)',
        },
        mb:2
      }}
    >
      {/* Reservation Text */}
    
        <Typography
          sx={{
            color: Css?.salonCardSectionHeadingClr,
            fontSize: { md: "18px", sm: "16px", xs: "14px" },
            fontWeight: "bold",
            mb: 1,
          }}
        >
        {widgetSettings?.company?.company}
        </Typography>
      

      {/* Company Name */}
      <Typography
        sx={{
          color: Css?.salonCardSectionInfoClr,
          fontWeight: "bold",
          fontSize: { md: "24px", sm: "20px", xs: "18px" },
          mb: 1,
        }}
      >
        {widgetConfig?.company?.company}
      </Typography>

      {/* Address Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        //  backgroundColor: theme?.details?.detailsBgColor,
          padding: "10px",
          borderRadius: "8px",
        }}
      >
        <LocationOnTwoToneIcon
          sx={{
            color: Css?.salonCardSectionIconClr,
            fontSize: "24px",
          }}
        />
        <Typography
          sx={{
            color: Css?.salonCardSectionInfoClr,
            fontSize: "14px",
            //fontWeight: "600",
          }}
        >
          {widgetSettings?.company?.address}, {widgetSettings?.company?.zipcode}, {widgetSettings?.company?.city}
        </Typography>
      </Box>
    </Box>
  );
};

export default AddressCard;



